import React from 'react'

import ActivityFilled from '../svg/ActivityFilled'
import ActivityOutlined from '../svg/ActivityOutlined'
import Add from '../svg/Add'
import AddNoteFilled from '../svg/AddNoteFilled'
import AddNoteOutlined from '../svg/AddNoteOutlined'
import AddUserFilled from '../svg/AddUserFilled'
import AddUserOutlined from '../svg/AddUserOutlined'
import Address from '../svg/Address'
import Analysis from '../svg/Analysis'
import AnnounceOutlined from '../svg/AnnounceOutlined'
import ArrowBack from '../svg/ArrowBack'
import ArrowDown from '../svg/ArrowDown'
import ArrowForward from '../svg/ArrowForward'
import ArrowLeft from '../svg/ArrowLeft'
import ArrowRight from '../svg/ArrowRight'
import ArrowTop from '../svg/ArrowTop'
import AssignTaskFilled from '../svg/AssignTaskFilled'
import AssignTaskOutlined from '../svg/AssignTaskOutlined'
import AssignedFilled from '../svg/AssignedFilled'
import AssignedOutlined from '../svg/AssignedOutlined'
import BankAccount from '../svg/BankAccount'
import BankAccountCategories from '../svg/BankAccountCategories'
import BankAccountWithColor from '../svg/BankAccountWithColor'
import BankFilled from '../svg/BankFilled'
import BankOutlined from '../svg/BankOutlined'
import BusinessShopOutlined from '../svg/BusinessLoan'
import BusinessLoans from '../svg/BusinessLoans'
import CalenderOutlined from '../svg/CalenderOutlined'
import CallCancelFilled from '../svg/CallCancelFilled'
import CallCancelOutlined from '../svg/CallCancelOutlined'
import CallIncomingFilled from '../svg/CallIncomingFilled'
import CallIncomingOutlined from '../svg/CallIncomingOutlined'
import CallOutgoingFilled from '../svg/CallOutgoingFilled'
import CallOutgoingOutlined from '../svg/CallOutgoingOutlined'
import CameraFilled from '../svg/CameraFilled'
import CameraOutlined from '../svg/CameraOutlined'
import Cash from '../svg/Cash'
import CashWithColor from '../svg/CashWithColor'
import CautionFilled from '../svg/CautionFilled'
import CautionOutlined from '../svg/CautionOutlined'
import CertificateBadge from '../svg/CertificateBadge'
import Chat from '../svg/Chat'
import ChatFilled from '../svg/ChatFilled'
import ChatOutlined from '../svg/ChatOutlined'
import ChatSupport from '../svg/ChatSupport'
import ChatSupportFilled from '../svg/ChatSupportFilled'
import ChatSupportOutlined from '../svg/ChatSupportOutlined'
import CheckBox from '../svg/CheckBox'
import CheckBoxSmallFilled from '../svg/CheckBoxSmallFilled'
import CheckBoxTickFilled from '../svg/CheckBoxTickFilled'
import CheckBoxTickOutlined from '../svg/CheckBoxTickOutlined'
import CircleCloseFilled from '../svg/CircleCloseFilled'
import CircleCloseOutlined from '../svg/CircleCloseOutlined'
import ClockFilled from '../svg/ClockFilled'
import ClockOutlined from '../svg/ClockOutlined'
import Close from '../svg/Close'
import CreditCardCategories from '../svg/CreditCardCategories'
import CreditCardFilled from '../svg/CreditCardFilled'
import CreditCardOptions from '../svg/CreditCardOptions'
import CreditCardOutlined from '../svg/CreditCardOutlined'
import CreditScore from '../svg/CreditScore'
import CreditScoreExcellent from '../svg/CreditScoreExcellent'
import CreditScoreHigh from '../svg/CreditScoreHigh'
import CreditScoreLow from '../svg/CreditScoreLow'
import CreditScoreMedium from '../svg/CreditScoreMedium'
import DOB from '../svg/DOB'
import DashboardFilled from '../svg/DashboardFilled'
import DashboardOutlined from '../svg/DashboardOutlined'
import DashedBorder from '../svg/DashedBorder'
import DayFilled from '../svg/DayFilled'
import DayOutlined from '../svg/DayOutlined'
import DeleteFilled from '../svg/DeleteFilled'
import DeleteOutlined from '../svg/DeleteOutlined'
import DigitalGoldCategories from '../svg/DigitalGoldCategories'
import DocumentFilled from '../svg/DocumentFilled'
import DocumentOutlined from '../svg/DocumentOutlined'
import DocumentPendingFilled from '../svg/DocumentPendingFilled'
import DocumentPendingOutlined from '../svg/DocumentPendingOutlined'
import DoneFilled from '../svg/DoneFilled'
import DoneOutlined from '../svg/DoneOutlined'
import Download from '../svg/Download'
import Edit from '../svg/Edit'
import EditDocFilled from '../svg/EditDocFilled'
import EditDocOutlined from '../svg/EditDocOutlined'
import EditFilled from '../svg/EditFilled'
import EditOutlined from '../svg/EditOutlined'
import Eligible from '../svg/Eligible'
import Email from '../svg/Email'
import EmailOutlined from '../svg/EmailOutlined'
import English from '../svg/English'
import ErrorFilled from '../svg/ErrorFilled'
import ErrorOutlined from '../svg/ErrorOutlined'
import Expand from '../svg/Expand'
import ExpiredFilled from '../svg/ExpiredFilled'
import ExpiredOutlined from '../svg/ExpiredOutlined'
import EyeFilled from '../svg/EyeFilled'
import EyeOutlined from '../svg/EyeOutlined'
import FAQ from '../svg/FAQ'
import Filter from '../svg/Filter'
import FilterFilled from '../svg/FilterFilled'
import FilterOutlined from '../svg/FilterOutlined'
import Folder from '../svg/Folder'
import FolderWithColor from '../svg/FolderWithColor'
import Gift from '../svg/Gift'
import GirlWithShortHairProfile from '../svg/GirlWithShortHairProfile'
import GoldBarsOutlined from '../svg/GoldBarsOutlined'
import GroupFilled from '../svg/GroupFilled'
import GroupOutlined from '../svg/GroupOutlined'
import HeadphonesFilled from '../svg/HeadphonesFilled'
import HeadphonesOutlined from '../svg/HeadphonesOutlined'
import Hide from '../svg/Hide'
import HighQuality from '../svg/HighQuality'
import Hindi from '../svg/Hindi'
import HomeFilled from '../svg/HomeFilled'
import HomeOutlined from '../svg/HomeOutlined'
import IconPlaceHolder from '../svg/IconPlaceHolder'
import IdCard from '../svg/IdCard'
import IdCardOutlined from '../svg/IdCardOutlined'
import InEligible from '../svg/InEligible'
import InEligibleBankAccout from '../svg/InEligibleBankAccount'
import InEligiCreditCategories from '../svg/InEligibleCreditCard'
import InEligibleLoans from '../svg/InEligibleLoans'
import InProgress from '../svg/InProgress'
import InfoFilled from '../svg/InfoFilled'
import InfoOutlined from '../svg/InfoOutlined'
import Instagram from '../svg/Instagram'
import InstantLoans from '../svg/InstantLoan'
import Keypad from '../svg/Keypad'
import LanguageFilled from '../svg/LanguageFilled'
import LanguageOutlined from '../svg/LanguageOutlined'
import LeadsFilled from '../svg/LeadsFilled'
import LeadsOutlined from '../svg/LeadsOutlined'
import LeftInvertedComa from '../svg/LeftInvertedComa'
import LinkOutlined from '../svg/LinkOutlined'
import Linkdin from '../svg/Linkdin'
import LoansCategories from '../svg/LoansCategories'
import LocationFilled from '../svg/LocationFilled'
import LocationOutlined from '../svg/LocationOutlined'
import LocationPointerFilled from '../svg/LocationPointerFilled'
import LocationPointerOutlined from '../svg/LocationPointerOutlined'
import Logout from '../svg/Logout'
import LowInterestRates from '../svg/LowInterstRates'
import MailOutlined from '../svg/MailOutlined'
import ManWithShortHairProfile from '../svg/ManWithShortHairProfile'
import MessageFilled from '../svg/MessageFilled'
import MessageOutlined from '../svg/MessageOutlined'
import MicFilled from '../svg/MicFilled'
import MicOffFilled from '../svg/MicOffFilled'
import MicOffOutlined from '../svg/MicOffOutlined'
import MicOutlined from '../svg/MicOutlined'
import MoneyBagFilled from '../svg/MoneyBagFilled'
import MoneyBagOutlined from '../svg/MoneyBagOutlined'
import MoreFilled from '../svg/MoreFilled'
import MoreHorizontal from '../svg/MoreHorizontal'
import MoreOutlined from '../svg/MoreOutlined'
import MoreVertical from '../svg/MoreVertical'
import MyAccount from '../svg/MyAccount'
import MyCustFiltersIcon from '../svg/MyCustFiltersIcon'
import MyTeam from '../svg/MyTeam'
import Notification from '../svg/Notification'
import NotificationFilled from '../svg/NotificationFilled'
import NotificationOutlined from '../svg/NotificationOutlined'
import OfferLetter from '../svg/OfferLetter'
import OfferOutlined from '../svg/OfferOutlined'
import Pause from '../svg/Pause'
import PayLaterEmi from '../svg/PayLaterEmi'
import PaymentDetails from '../svg/PaymentDetails'
import Paytm from '../svg/Paytm'
import PencilIcon from '../svg/PencilIcon'
import Pending from '../svg/Pending'
import PendingRounded from '../svg/PendingRounded'
import PhoneFilled from '../svg/PhoneFilled'
import PhoneOutlined from '../svg/PhoneOutlined'
import PhoneRingingFilled from '../svg/PhoneRingingFilled'
import PhoneRingingOutlined from '../svg/PhoneRingingOutlined'
import PhonebookFilled from '../svg/PhonebookFilled'
import PhotoFilled from '../svg/PhotoFilled'
import PhotoOutlined from '../svg/PhotoOutlined'
import PhotosFilled from '../svg/PhotosFilled'
import PhotosOutlined from '../svg/PhotosOutlined'
import PinCode from '../svg/PinCode'
import Play from '../svg/Play'
import Preferences from '../svg/Preferences'
import PrivacyAndPolicy from '../svg/PrivacyAndPolicy'
import ProfileFilled from '../svg/ProfileFilled'
import ProfileOutlined from '../svg/ProfileOutlined'
import ProfileReward from '../svg/ProfileRewards'
import QuestionMarkOutlined from '../svg/QuestionMarkOutlined'
import Quiz from '../svg/Quiz'
import RadioOff from '../svg/RadioOff'
import RadioOn from '../svg/RadioOn'
import Rewards from '../svg/Rewards'
import RewardsEdit from '../svg/RewardsEdit'
import RewardsFrame from '../svg/RewardsFrame'
import RightInvertedComa from '../svg/RightInvertedComa'
import RupeeCircleFilled from '../svg/RupeeCircleFilled'
import RupeeCircleOutlined from '../svg/RupeeCircleOutlined'
import SearchFilled from '../svg/SearchFilled'
import SearchOutlined from '../svg/SearchOutlined'
import SecureFilled from '../svg/SecureFilled'
import SecureOutlined from '../svg/SecureOutlined'
import SecuredCard from '../svg/SecuredCard'
import Security from '../svg/Security'
import SettingsFilled from '../svg/SettingsFilled'
import SettingsOutlined from '../svg/SettingsOutlined'
import Share from '../svg/Share'
import Show from '../svg/Show'
import Sort from '../svg/Sort'
import Sorting from '../svg/Sorting'
import Stop from '../svg/Stop'
import StudyMaterialFilled from '../svg/StudyMaterialFilled'
import StudyMaterialOutlined from '../svg/StudyMaterialOutlined'
import TagFilled from '../svg/TagFilled'
import TagOutlined from '../svg/TagOutlined'
import Target from '../svg/Target'
import Telegram from '../svg/Telegram'
import TermsAndConditions from '../svg/TermsAndConditions'
import Tick from '../svg/Tick'
import Timeline from '../svg/Timeline'
import Transfer1 from '../svg/Transfer1'
import Transfer2 from '../svg/Transfer2'
import Transfer3 from '../svg/Transfer3'
import UnAssignedOutlined from '../svg/UnAssignedOutlined'
import UploadFilled from '../svg/UploadOutlined'
import UserFilled from '../svg/UserFilled'
import UserGroupFilled from '../svg/UserGroupFilled'
import UserGroupOutlined from '../svg/UserGroupOutlined'
import UserOutlined from '../svg/UserOutlined'
import VerificationPendingFilled from '../svg/VerificationPendingFilled'
import VerificationPendingOutlined from '../svg/VerificationPendingOutlined'
import VerifiedFilled from '../svg/VerifiedFilled'
import VerifiedOutlined from '../svg/VerifiedOutlined'
import VideoFilled from '../svg/VideoFilled'
import VideoOutlined from '../svg/VideoOutlined'
import VisitingCard from '../svg/VisitingCard'
import Wallet from '../svg/Wallet'
import Whatsapp from '../svg/Whatsapp'
import WhatsappLogo from '../svg/WhatsappLogo'
import WorkBag from '../svg/WorkBag'
import WorkBagWithColor from '../svg/WorkBagWithColor'
import WorkExp from '../svg/WorkExp'
import WorkOutlined from '../svg/WorkOutlined'
import Youtube from '../svg/Youtube'
import ZetPrime from '../svg/ZetPrime'
import AddPlus from '../svg/addPlus'
import ApplicationDoneFilled from '../svg/applicationDoneFilled'
import CurrencyNoteMoney from '../svg/currencyNoteMoney'
import DocumentInvalidOutlined from '../svg/documentInvalidOutlined'
import GrowFilled from '../svg/growFilled'
import GrowOutlined from '../svg/growOutlined'
import IncreaseHighGrowth from '../svg/increaseHighGrowth'
import LockOutLined from '../svg/lockOutlined'
import OfferPrecent from '../svg/offerPrecent'
import Send from '../svg/send'
import Star from '../svg/star'
import TagInfo from '../svg/tagInfo'
import TagNew from '../svg/tagNew'
import TopAgentCustomerOutline from '../svg/topAgentCustomerOutline'
import UnAssignedUserError from '../svg/unAssignedUserError'

export interface SVGProps extends React.SVGProps<SVGSVGElement> {
  type: string
  color?: string
  size?: number
  className?: string
  onPress?: () => void
}

export function Icon({ type, color = '#000', size = 24, ...props }: SVGProps) {
  //* Render the icon based on type
  switch (type) {
    case 'ActivityFilled':
      return <ActivityFilled color={color} size={size} {...props} />
    case 'DashedBorder':
      return <DashedBorder {...props} />
    case 'ApplicationDoneFilled':
      return <ApplicationDoneFilled color={color} size={size} {...props} />
    case 'Address':
      return <Address color={color} size={size} {...props} />
    case 'AnnounceOutlined':
      return <AnnounceOutlined color={color} size={size} {...props} />
    case 'ActivityOutlined':
      return <ActivityOutlined color={color} size={size} {...props} />
    case 'Add':
      return <Add color={color} size={size} {...props} />
    case 'AddNoteFilled':
      return <AddNoteFilled color={color} size={size} {...props} />
    case 'AddNoteOutlined':
      return <AddNoteOutlined color={color} size={size} {...props} />
    case 'AddUserFilled':
      return <AddUserFilled color={color} size={size} {...props} />
    case 'AddUserOutlined':
      return <AddUserOutlined color={color} size={size} {...props} />
    case 'ArrowBack':
      return <ArrowBack color={color} size={size} {...props} />
    case 'ArrowDown':
      return <ArrowDown color={color} size={size} {...props} />
    case 'ArrowForward':
      return <ArrowForward color={color} size={size} {...props} />
    case 'ArrowLeft':
      return <ArrowLeft color={color} size={size} {...props} />
    case 'ArrowRight':
      return <ArrowRight color={color} size={size} {...props} />
    case 'ArrowTop':
      return <ArrowTop color={color} size={size} {...props} />
    case 'AssignedFilled':
      return <AssignedFilled color={color} size={size} {...props} />
    case 'AssignedOutlined':
      return <AssignedOutlined color={color} size={size} {...props} />
    case 'AssignTaskFilled':
      return <AssignTaskFilled color={color} size={size} {...props} />
    case 'AssignTaskOutlined':
      return <AssignTaskOutlined color={color} size={size} {...props} />
    case 'BankFilled':
      return <BankFilled color={color} size={size} {...props} />
    case 'BankOutlined':
      return <BankOutlined color={color} size={size} {...props} />
    case 'CallCancelFilled':
      return <CallCancelFilled color={color} size={size} {...props} />
    case 'CallCancelOutlined':
      return <CallCancelOutlined color={color} size={size} {...props} />
    case 'CallIncomingFilled':
      return <CallIncomingFilled color={color} size={size} {...props} />
    case 'CallIncomingOutlined':
      return <CallIncomingOutlined color={color} size={size} {...props} />
    case 'CallOutgoingFilled':
      return <CallOutgoingFilled color={color} size={size} {...props} />
    case 'CallOutgoingOutlined':
      return <CallOutgoingOutlined color={color} size={size} {...props} />
    case 'CameraFilled':
      return <CameraFilled color={color} size={size} {...props} />
    case 'CameraOutlined':
      return <CameraOutlined color={color} size={size} {...props} />
    case 'CautionFilled':
      return <CautionFilled color={color} size={size} {...props} />
    case 'CautionOutlined':
      return <CautionOutlined color={color} size={size} {...props} />
    case 'Chat':
      return <Chat color={color} size={size} {...props} />
    case 'ChatFilled':
      return <ChatFilled color={color} size={size} {...props} />
    case 'ChatOutlined':
      return <ChatOutlined color={color} size={size} {...props} />
    case 'ChatSupportFilled':
      return <ChatSupportFilled color={color} size={size} {...props} />
    case 'ChatSupportOutlined':
      return <ChatSupportOutlined color={color} size={size} {...props} />
    case 'CheckBox':
      return <CheckBox color={color} size={size} {...props} />
    case 'CheckBoxSmallFilled':
      return <CheckBoxSmallFilled color={color} size={size} {...props} />
    case 'CheckBoxTickFilled':
      return <CheckBoxTickFilled color={color} size={size} {...props} />
    case 'CheckBoxTickOutlined':
      return <CheckBoxTickOutlined color={color} size={size} {...props} />
    case 'CircleCloseFilled':
      return <CircleCloseFilled color={color} size={size} {...props} />
    case 'CircleCloseOutlined':
      return <CircleCloseOutlined color={color} size={size} {...props} />
    case 'ClockFilled':
      return <ClockFilled color={color} size={size} {...props} />
    case 'ClockOutlined':
      return <ClockOutlined color={color} size={size} {...props} />
    case 'Close':
      return <Close color={color} size={size} {...props} />
    case 'CreditCardFilled':
      return <CreditCardFilled color={color} size={size} {...props} />
    case 'CreditCardOutlined':
      return <CreditCardOutlined color={color} size={size} {...props} />
    case 'CreditScore':
      return <CreditScore color={color} size={size} {...props} />
    case 'DashboardFilled':
      return <DashboardFilled color={color} size={size} {...props} />
    case 'DashboardOutlined':
      return <DashboardOutlined color={color} size={size} {...props} />
    case 'DayFilled':
      return <DayFilled color={color} size={size} {...props} />
    case 'DayOutlined':
      return <DayOutlined color={color} size={size} {...props} />
    case 'DeleteFilled':
      return <DeleteFilled color={color} size={size} {...props} />
    case 'DeleteOutlined':
      return <DeleteOutlined color={color} size={size} {...props} />
    case 'DOB':
      return <DOB color={color} size={size} {...props} />
    case 'DocumentFilled':
      return <DocumentFilled color={color} size={size} {...props} />
    case 'DocumentOutlined':
      return <DocumentOutlined color={color} size={size} {...props} />
    case 'DocumentPendingOutlined':
      return <DocumentPendingOutlined color={color} size={size} {...props} />
    case 'DocumentInvalidOutlined':
      return <DocumentInvalidOutlined color={color} size={size} {...props} />
    case 'DocumentPendingFilled':
      return <DocumentPendingFilled color={color} size={size} {...props} />
    case 'DoneFilled':
      return <DoneFilled color={color} size={size} {...props} />
    case 'DoneOutlined':
      return <DoneOutlined color={color} size={size} {...props} />
    case 'Download':
      return <Download color={color} size={size} {...props} />
    case 'Edit':
      return <Edit color={color} size={size} {...props} />
    case 'EditDocFilled':
      return <EditDocFilled color={color} size={size} {...props} />
    case 'EditDocOutlined':
      return <EditDocOutlined color={color} size={size} {...props} />
    case 'EditFilled':
      return <EditFilled color={color} size={size} {...props} />
    case 'EditOutlined':
      return <EditOutlined color={color} size={size} {...props} />
    case 'ErrorFilled':
      return <ErrorFilled color={color} size={size} {...props} />
    case 'ErrorOutlined':
      return <ErrorOutlined color={color} size={size} {...props} />
    case 'ExpiredFilled':
      return <ExpiredFilled color={color} size={size} {...props} />
    case 'ExpiredOutlined':
      return <ExpiredOutlined color={color} size={size} {...props} />
    case 'Email':
      return <Email color={color} size={size} {...props} />
    case 'EmailOutlined':
      return <EmailOutlined color={color} size={size} {...props} />
    case 'Expand':
      return <Expand color={color} size={size} {...props} />
    case 'EyeFilled':
      return <EyeFilled color={color} size={size} {...props} />
    case 'EyeOutlined':
      return <EyeOutlined color={color} size={size} {...props} />
    case 'Filter':
      return <Filter color={color} size={size} {...props} />
    case 'FilterFilled':
      return <FilterFilled color={color} size={size} {...props} />
    case 'FilterOutlined':
      return <FilterOutlined color={color} size={size} {...props} />
    case 'Gift':
      return <Gift color={color} size={size} {...props} />
    case 'GrowOutlined':
      return <GrowOutlined color={color} size={size} {...props} />
    case 'GrowFilled':
      return <GrowFilled color={color} size={size} {...props} />
    case 'GroupFilled':
      return <GroupFilled color={color} size={size} {...props} />
    case 'GroupOutlined':
      return <GroupOutlined color={color} size={size} {...props} />
    case 'HeadphonesFilled':
      return <HeadphonesFilled color={color} size={size} {...props} />
    case 'HeadphonesOutlined':
      return <HeadphonesOutlined color={color} size={size} {...props} />
    case 'HomeFilled':
      return <HomeFilled color={color} size={size} {...props} />
    case 'HomeOutlined':
      return <HomeOutlined color={color} size={size} {...props} />
    case 'IconPlaceHolder':
      return <IconPlaceHolder color={color} size={size} {...props} />
    case 'MyCustFiltersIcon':
      return <MyCustFiltersIcon color={color} size={size} {...props} />
    case 'InfoFilled':
      return <InfoFilled color={color} size={size} {...props} />
    case 'InfoOutlined':
      return <InfoOutlined color={color} size={size} {...props} />
    case 'Pending':
      return <Pending color={color} size={size} {...props} />
    case 'IdCard':
      return <IdCard color={color} size={size} {...props} />
    case 'Keypad':
      return <Keypad color={color} size={size} {...props} />
    case 'LanguageFilled':
      return <LanguageFilled color={color} size={size} {...props} />
    case 'LanguageOutlined':
      return <LanguageOutlined color={color} size={size} {...props} />
    case 'LeadsFilled':
      return <LeadsFilled color={color} size={size} {...props} />
    case 'LockOutLined':
      return <LockOutLined color={color} size={size} {...props} />
    case 'LeadsOutlined':
      return <LeadsOutlined color={color} size={size} {...props} />
    case 'LocationFilled':
      return <LocationFilled color={color} size={size} {...props} />
    case 'LocationOutlined':
      return <LocationOutlined color={color} size={size} {...props} />
    case 'LocationPointerFilled':
      return <LocationPointerFilled color={color} size={size} {...props} />
    case 'LocationPointerOutlined':
      return <LocationPointerOutlined color={color} size={size} {...props} />
    case 'MessageFilled':
      return <MessageFilled color={color} size={size} {...props} />
    case 'MessageOutlined':
      return <MessageOutlined color={color} size={size} {...props} />
    case 'MicFilled':
      return <MicFilled color={color} size={size} {...props} />
    case 'MicOffFilled':
      return <MicOffFilled color={color} size={size} {...props} />
    case 'MicOffOutlined':
      return <MicOffOutlined color={color} size={size} {...props} />
    case 'MicOutlined':
      return <MicOutlined color={color} size={size} {...props} />
    case 'MoneyBagFilled':
      return <MoneyBagFilled color={color} size={size} {...props} />
    case 'MoneyBagOutlined':
      return <MoneyBagOutlined color={color} size={size} {...props} />
    case 'MoreFilled':
      return <MoreFilled color={color} size={size} {...props} />
    case 'MoreHorizontal':
      return <MoreHorizontal color={color} size={size} {...props} />
    case 'MoreOutlined':
      return <MoreOutlined color={color} size={size} {...props} />
    case 'MoreVertical':
      return <MoreVertical color={color} size={size} {...props} />
    case 'MyAccount':
      return <MyAccount color={color} size={size} {...props} />
    case 'MyTeam':
      return <MyTeam color={color} size={size} {...props} />
    case 'NotificationFilled':
      return <NotificationFilled color={color} size={size} {...props} />
    case 'LinkOutlined':
      return <LinkOutlined color={color} size={size} {...props} />
    case 'NotificationOutlined':
      return <NotificationOutlined color={color} size={size} {...props} />
    case 'OfferLetter':
      return <OfferLetter color={color} size={size} {...props} />
    case 'OfferPrecent':
      return <OfferPrecent color={color} size={size} {...props} />
    case 'OfferOutlined':
      return <OfferOutlined color={color} size={size} {...props} />
    case 'Pause':
      return <Pause color={color} size={size} {...props} />
    case 'PencilIcon':
      return <PencilIcon color={color} size={size} {...props} />
    case 'PhoneFilled':
      return <PhoneFilled color={color} size={size} {...props} />
    case 'PhoneOutlined':
      return <PhoneOutlined color={color} size={size} {...props} />
    case 'PhoneRingingFilled':
      return <PhoneRingingFilled color={color} size={size} {...props} />
    case 'PhoneRingingOutlined':
      return <PhoneRingingOutlined color={color} size={size} {...props} />
    case 'PhotoFilled':
      return <PhotoFilled color={color} size={size} {...props} />
    case 'PhotoOutlined':
      return <PhotoOutlined color={color} size={size} {...props} />
    case 'PhotosFilled':
      return <PhotosFilled color={color} size={size} {...props} />
    case 'PhotosOutlined':
      return <PhotosOutlined color={color} size={size} {...props} />
    case 'PhonebookFilled':
      return <PhonebookFilled color={color} size={size} {...props} />
    case 'Play':
      return <Play color={color} size={size} {...props} />
    case 'Preferences':
      return <Preferences color={color} size={size} {...props} />
    case 'ProfileFilled':
      return <ProfileFilled color={color} size={size} {...props} />
    case 'PaymentDetails':
      return <PaymentDetails color={color} size={size} {...props} />
    case 'ProfileOutlined':
      return <ProfileOutlined color={color} size={size} {...props} />
    case 'PinCode':
      return <PinCode color={color} size={size} {...props} />
    case 'RadioOff':
      return <RadioOff color={color} size={size} {...props} />
    case 'RadioOn':
      return <RadioOn color={color} size={size} {...props} />
    case 'RupeeCircleFilled':
      return <RupeeCircleFilled color={color} size={size} {...props} />
    case 'RupeeCircleOutlined':
      return <RupeeCircleOutlined color={color} size={size} {...props} />
    case 'SearchFilled':
      return <SearchFilled color={color} size={size} {...props} />
    case 'SearchOutlined':
      return <SearchOutlined color={color} size={size} {...props} />
    case 'SecureFilled':
      return <SecureFilled color={color} size={size} {...props} />
    case 'SecureOutlined':
      return <SecureOutlined color={color} size={size} {...props} />
    case 'SettingsFilled':
      return <SettingsFilled color={color} size={size} {...props} />
    case 'SettingsOutlined':
      return <SettingsOutlined color={color} size={size} {...props} />
    case 'Share':
      return <Share color={color} size={size} {...props} />
    case 'Show':
      return <Show color={color} size={size} {...props} />
    case 'Sort':
      return <Sort color={color} size={size} {...props} />
    case 'StudyMaterialFilled':
      return <StudyMaterialFilled color={color} size={size} {...props} />
    case 'StudyMaterialOutlined':
      return <StudyMaterialOutlined color={color} size={size} {...props} />
    case 'TagFilled':
      return <TagFilled color={color} size={size} {...props} />
    case 'TagOutlined':
      return <TagOutlined color={color} size={size} {...props} />
    case 'Target':
      return <Target color={color} size={size} {...props} />
    case 'Tick':
      return <Tick color={color} size={size} {...props} />
    case 'Timeline':
      return <Timeline color={color} size={size} {...props} />
    case 'Transfer1':
      return <Transfer1 color={color} size={size} {...props} />
    case 'Transfer2':
      return <Transfer2 color={color} size={size} {...props} />
    case 'Transfer3':
      return <Transfer3 color={color} size={size} {...props} />
    case 'UserFilled':
      return <UserFilled color={color} size={size} {...props} />
    case 'UserOutlined':
      return <UserOutlined color={color} size={size} {...props} />
    case 'VerifiedFilled':
      return <VerifiedFilled color={color} size={size} {...props} />
    case 'VerifiedOutlined':
      return <VerifiedOutlined color={color} size={size} {...props} />
    case 'VideoFilled':
      return <VideoFilled color={color} size={size} {...props} />
    case 'VideoOutlined':
      return <VideoOutlined color={color} size={size} {...props} />
    case 'VisitingCard':
      return <VisitingCard color={color} size={size} {...props} />
    case 'Whatsapp':
      return <Whatsapp color={color} size={size} {...props} />
    case 'WhatsappLogo':
      return <WhatsappLogo color={color} size={size} {...props} />
    case 'WorkExp':
      return <WorkExp color={color} size={size} {...props} />
    case 'Telegram':
      return <Telegram color={color} size={size} {...props} />
    case 'Youtube':
      return <Youtube color={color} size={size} {...props} />
    case 'Linkdin':
      return <Linkdin color={color} size={size} {...props} />
    case 'Instagram':
      return <Instagram color={color} size={size} {...props} />
    case 'LeftInvertedComa':
      return <LeftInvertedComa color={color} size={size} {...props} />
    case 'RightInvertedComa':
      return <RightInvertedComa color={color} size={size} {...props} />
    case 'Rewards':
      return <Rewards color={color} size={size} {...props} />
    case 'LowInterestRates':
      return <LowInterestRates color={color} size={size} {...props} />
    case 'InstantLoans':
      return <InstantLoans color={color} size={size} {...props} />
    case 'CreditCardOptions':
      return <CreditCardOptions color={color} size={size} {...props} />
    case 'VerificationPendingOutlined':
      return (
        <VerificationPendingOutlined color={color} size={size} {...props} />
      )
    case 'VerificationPendingFilled':
      return <VerificationPendingFilled color={color} size={size} {...props} />
    case 'ManWithShortHairProfile':
      return <ManWithShortHairProfile color={color} size={size} {...props} />
    case 'GirlWithShortHairProfile':
      return <GirlWithShortHairProfile color={color} size={size} {...props} />
    case 'Paytm':
      return <Paytm color={color} size={size} {...props} />
    case 'IdCardOutlined':
      return <IdCardOutlined color={color} size={size} {...props} />
    case 'WorkBag':
      return <WorkBag color={color} size={size} {...props} />
    case 'WorkOutlined':
      return <WorkOutlined color={color} size={size} {...props} />
    case 'WorkBagWithColor':
      return <WorkBagWithColor color={color} size={size} {...props} />
    case 'Folder':
      return <Folder color={color} size={size} {...props} />
    case 'FolderWithColor':
      return <FolderWithColor color={color} size={size} {...props} />
    case 'BankAccount':
      return <BankAccount color={color} size={size} {...props} />
    case 'Cash':
      return <Cash color={color} size={size} {...props} />
    case 'BankAccountWithColor':
      return <BankAccountWithColor color={color} size={size} {...props} />
    case 'CashWithColor':
      return <CashWithColor color={color} size={size} {...props} />
    case 'CreditScoreExcellent':
      return <CreditScoreExcellent color={color} size={size} {...props} />
    case 'CreditScoreHigh':
      return <CreditScoreHigh color={color} size={size} {...props} />
    case 'CreditScoreMedium':
      return <CreditScoreMedium color={color} size={size} {...props} />
    case 'CreditScoreLow':
      return <CreditScoreLow color={color} size={size} {...props} />
    case 'HighQuality':
      return <HighQuality color={color} size={size} {...props} />
    case 'InEligible':
      return <InEligible color={color} size={size} {...props} />
    case 'Wallet':
      return <Wallet color={color} size={size} {...props} />
    case 'QuestionMarkOutlined':
      return <QuestionMarkOutlined color={color} size={size} {...props} />
    case 'UserGroupOutlined':
      return <UserGroupOutlined color={color} size={size} {...props} />
    case 'UserGroupFilled':
      return <UserGroupFilled color={color} size={size} {...props} />
    case 'CalenderOutlined':
      return <CalenderOutlined color={color} size={size} {...props} />
    case 'Analysis':
      return <Analysis size={size} {...props} />
    case 'UnAssignedOutlined':
      return <UnAssignedOutlined color={color} size={size} {...props} />
    case 'Stop':
      return <Stop color={color} size={size} {...props} />
    case 'MailOutlined':
      return <MailOutlined color={color} size={size} {...props} />
    case 'CertificateBadge':
      return <CertificateBadge color={color} size={size} {...props} />
    case 'English':
      return <English color={color} size={size} {...props} />
    case 'Hindi':
      return <Hindi color={color} size={size} {...props} />
    case 'Hide':
      return <Hide color={color} size={size} {...props} />
    case 'Eligible':
      return <Eligible color={color} size={size} {...props} />
    case 'Sorting':
      return <Sorting color={color} size={size} {...props} />
    case 'CreditCardCategories':
      return <CreditCardCategories color={color} size={size} {...props} />
    case 'BankAccountCategories':
      return <BankAccountCategories color={color} size={size} {...props} />
    case 'DigitalGoldCategories':
      return <DigitalGoldCategories color={color} size={size} {...props} />
    case 'LoansCategories':
      return <LoansCategories color={color} size={size} {...props} />
    case 'InEligibleCreditCategories':
      return <InEligiCreditCategories color={color} size={size} {...props} />
    case 'InEligibleLoans':
      return <InEligibleLoans color={color} size={size} {...props} />
    case 'SecuredCard':
      return <SecuredCard color={color} size={size} {...props} />
    case 'BusinessLoans':
      return <BusinessLoans color={color} size={size} {...props} />
    case 'InEligibleBankAccount':
      return <InEligibleBankAccout color={color} size={size} {...props} />
    case 'InProgress':
      return <InProgress color={color} size={size} {...props} />
    case 'PayLaterEmi':
      return <PayLaterEmi color={color} size={size} {...props} />
    case 'UnAssignedUserError':
      return <UnAssignedUserError color={color} size={size} {...props} />
    case 'ProfileReward':
      return <ProfileReward color={color} size={size} {...props} />
    case 'Logout':
      return <Logout color={color} size={size} {...props} />
    case 'Security':
      return <Security color={color} size={size} {...props} />
    case 'PrivacyAndPolicy':
      return <PrivacyAndPolicy color={color} size={size} {...props} />
    case 'TermsAndConditions':
      return <TermsAndConditions color={color} size={size} {...props} />
    case 'FAQ':
      return <FAQ color={color} size={size} {...props} />
    case 'Notification':
      return <Notification color={color} size={size} {...props} />
    case 'ChatSupport':
      return <ChatSupport color={color} size={size} {...props} />
    case 'Quiz':
      return <Quiz color={color} size={size} {...props} />
    case 'RewardsFrame':
      return <RewardsFrame color={color} size={size} {...props} />
    case 'Star':
      return <Star color={color} size={size} {...props} />
    case 'TagNew':
      return <TagNew color={color} size={size} {...props} />
    case 'TagInfo':
      return <TagInfo color={color} size={size} {...props} />
    case 'RewardsEdit':
      return <RewardsEdit color={color} size={size} {...props} />
    case 'PendingRounded':
      return <PendingRounded color={color} size={size} {...props} />
    case 'TopAgentCustomerOutline':
      return <TopAgentCustomerOutline color={color} size={size} {...props} />
    case 'CurrencyNoteMoney':
      return <CurrencyNoteMoney color={color} size={size} {...props} />
    case 'Send':
      return <Send color={color} size={size} {...props} />
    case 'AddPlus':
      return <AddPlus color={color} size={size} {...props} />
    case 'IncreaseHighGrowth':
      return <IncreaseHighGrowth color={color} size={size} {...props} />
    case 'GoldBarsOutlined':
      return <GoldBarsOutlined color={color} size={size} {...props} />
    case 'BusinessShopOutlined':
      return <BusinessShopOutlined color={color} size={size} {...props} />
    case 'UploadFilled':
      return <UploadFilled color={color} size={size} {...props} />
    case 'ZetPrime':
      return <ZetPrime color={color} size={size} {...props} />
    default:
      return <></>
  }
}
